import React from 'react';
import BodyStep from '../../components/BodyStep';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';

const Balcao: React.FC = () => {
  const { changeStep } = useSteps();
  const { companyName } = useAuth();
  return (
    <>
      {companyName ? <BodyStep>{changeStep()}</BodyStep> : <>{changeStep()}</>}
    </>
  );
};

export default Balcao;
